import React, { Suspense, useState, useEffect } from "react";
import { Img } from 'react-image'
import { Spinner } from 'reactstrap'
import { useSelector } from 'react-redux'
import { config } from '_config'


const  AvatarProfile = ({ documentIdUser, photouser, getUserPhotoUser }) =>{

  console.log('photouser', photouser);
  
  const [urlphoto, setUrlPhoto] = useState('')
  const [idphotouser, setIdPhotoUser] = useState('')
  var codephoto

  function getUserPhoto() {
    // setUser(props.user)
    // fetch(`${config.apiEndPoint}/profilepictures/${idPhoto}`, {
    //   method: 'GET',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     // console.log('datadata', data);
    //     setUrlPhoto(data.photo)
    //     setIdPhotoUser(data.codePhoto)
    //     codephoto = data.codePhoto
    //   })
    //   .catch((error) => console.log(error))
    //   .finally(() => { })
    // console.log('idphotouser: **...', idphotouser)
  };


  var photoUrl = urlphoto
  if (photoUrl != undefined) {
    photoUrl = urlphoto
  } else {
    photoUrl = 'https://s3-sige-file-20200523.s3.amazonaws.com/media/ProfilePrictures/Instituci%C3%B3n%20Educativa%20Central%20de%20Bachillerato%20Integrado/52005409/SIGEBird.png'
  }
  // console.log('urlphoto', urlphoto);

  getUserPhoto()
  return (
    
    <Suspense>
      <img src={photoUrl} alt="" />
      {/* 
        // <svg width={200} height={200} viewBox="0 0 464.002 464.002" {...props}>
        //   <path
        //     d="M391.864 422.878l-.726-6.536a4.71 4.71 0 00-5.201-4.162l-.407.045-7.027-56.214a32.002 32.002 0 00-21.633-26.389l-44.914-14.972c-3.841-1.28-8.048.493-9.75 4.166-.078.168-.159.337-.237.506l-11.026-3.676a16 16 0 01-10.94-15.179v-25.802l34.461-14.359A47.996 47.996 0 00344.001 216v-8c13.255 0 24-10.745 24-24a23.892 23.892 0 00-4.989-14.641c4.809-23.816 13.571-70.214 12.959-89.359-.409-12.8-8.515-29.935-32-40-41.978-17.991-94.608-23.329-111.97-39.975V0l-.015.012-.015-.012v.025C214.609 16.671 161.979 22.009 120.001 40c-23.486 10.065-31.591 27.2-32 40-.612 19.153 8.157 65.583 12.965 89.39A23.889 23.889 0 0096.001 184c0 13.255 10.745 24 24 24v8a48.002 48.002 0 0029.538 44.308l34.462 14.36v25.801a16 16 0 01-10.94 15.179l-11.026 3.676c-.078-.168-.159-.337-.237-.506-1.703-3.673-5.91-5.446-9.75-4.166l-44.914 14.972a31.999 31.999 0 00-21.633 26.389l-7.027 56.214-.407-.045a4.711 4.711 0 00-5.202 4.162l-.726 6.536a4.71 4.71 0 004.161 5.201l11.702 1.3v18.621c0 8.836 7.163 16 16 16h256c8.837 0 16-7.164 16-16v-18.621l11.702-1.3a4.712 4.712 0 004.16-5.203z"
        //     fill="#f6b47b"
        //   />
        //   <path
        //     d="M184.001 274.001v26.468a15.994 15.994 0 01-7.753 13.701c66.926 11.563 103.753-40.169 103.753-40.169h-96z"
        //     fill="#e2a071"
        //   />
        //   <path
        //     d="M375.971 80c-.409-12.8-8.515-29.935-32-40-41.978-17.991-94.608-23.329-111.97-39.975V0l-.015.012-.015-.012v.025C214.609 16.671 161.979 22.009 120.001 40c-23.486 10.065-31.591 27.2-32 40-.84 26.293 16 104 16 104h255.97s16.84-77.707 16-104z"
        //     fill="#9d6e48"
        //   />
        //   <path
        //     d="M231.971 0v.025C214.609 16.671 161.979 22.009 120.001 40c-23.486 10.065-31.591 27.2-32 40-.84 26.293 16 104 16 104h72v-72c0-53.334 56-78.667 56-112l-.015.012-.015-.012z"
        //     fill="#8d5f3d"
        //   />
        //   <path
        //     d="M378.503 356.012a32 32 0 00-21.633-26.389l-44.914-14.972c-3.841-1.28-8.048.493-9.751 4.166-11.101 23.945-26.794 50.002-70.204 81.183-43.409-31.181-59.103-57.238-70.204-81.184-1.703-3.673-5.91-5.446-9.751-4.166l-44.914 14.972a31.999 31.999 0 00-21.633 26.389l-7.609 60.872L144.001 424v40h176v-40l66.11-7.117-7.608-60.871z"
        //     fill="#4f6e7f"
        //   />
        //   <path
        //     d="M344.001 160v-16c0-22.091-17.909-40-40-40h-144c-22.091 0-40 17.909-40 40v16c-13.255 0-24 10.745-24 24s10.745 24 24 24v8a48.002 48.002 0 0029.538 44.308l51.691 21.538a79.988 79.988 0 0061.539 0l51.694-21.539A47.997 47.997 0 00344.001 216v-8c13.255 0 24-10.745 24-24s-10.745-24-24-24z"
        //     fill="#fdc88e"
        //   />
        //   <path
        //     d="M176.001 192c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8zm112 0c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8z"
        //     fill="#623f33"
        //   />
        //   <path
        //     d="M232.001 248.219c-14.223 0-27.527-3.5-36.5-9.605-3.652-2.484-4.602-7.461-2.113-11.113 2.48-3.648 7.461-4.598 11.113-2.113 6.289 4.277 16.57 6.832 27.5 6.832s21.211-2.555 27.5-6.832a7.992 7.992 0 0111.113 2.113 7.997 7.997 0 01-2.113 11.113c-8.972 6.105-22.277 9.605-36.5 9.605z"
        //     fill="#e2a071"
        //   />
        //   <path
        //     d="M161.997 243.723c-6.482-6.95-9.995-16.121-9.995-25.625V104.806c-18.257 3.707-32 19.843-32 39.194v16c-13.255 0-24 10.745-24 24s10.745 24 24 24v8a48 48 0 0029.538 44.308l51.69 21.538a80.115 80.115 0 007.727 2.749c-22.845-16.712-38.051-31.32-46.96-40.872z"
        //     fill="#f6b47b"
        //   />
        //   <path
        //     d="M144.001 430.04v-18.106a32.004 32.004 0 00-7.813-20.953l-44.019-50.813c-3.552 4.497-5.93 9.93-6.669 15.843l-8.356 66.847c12.724.764 46.568 4.729 66.857 7.182z"
        //     fill="#33546a"
        //   />
        //   <path
        //     d="M144.001 419.507l-65.936-7.326a4.711 4.711 0 00-5.202 4.161l-.726 6.536a4.71 4.71 0 004.161 5.201l67.703 7.523v-16.095z"
        //     fill="#4f6e7f"
        //   />
        //   <path
        //     d="M320.001 430.04v-18.106a32.004 32.004 0 017.813-20.953l44.019-50.813c3.552 4.497 5.93 9.93 6.669 15.843l8.356 66.847c-12.723.764-46.568 4.729-66.857 7.182z"
        //     fill="#33546a"
        //   />
        //   <path
        //     d="M320.001 419.507l65.936-7.326a4.711 4.711 0 015.202 4.161l.726 6.536a4.71 4.71 0 01-4.161 5.201l-67.703 7.523v-16.095z"
        //     fill="#4f6e7f"
        //   />
        //   <path
        //     d="M269.924 100.001c11.224 7.947 35.758 27.131 50.077 52 0 0 .351-27.953-14.702-52h-35.375z"
        //     fill="#9d6e48"
        //   />
        // </svg>
         */}
    </Suspense>

  )
}

export default AvatarProfile